import React, { useState } from "react";

import { ShareAltOutlined } from "@ant-design/icons";
import { Button } from "antd";

import ShareModal from "./ShareModal";

interface ShareButtonProps {
  active?: boolean;
  contractLink: string;
  tenantPhoneNumber?: string;
  landlordPhoneNumber?: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({
  active = true,
  contractLink,
  tenantPhoneNumber,
  landlordPhoneNumber,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleShareClick = () => {
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Button
        type="default"
        icon={<ShareAltOutlined />}
        onClick={handleShareClick}
        disabled={!active || !contractLink}
        style={{
          width: 151,
        }}
      >
        Compartir
      </Button>

      <ShareModal
        open={isModalVisible}
        onCancel={handleModalCancel}
        contractLink={contractLink}
        tenantPhoneNumber={tenantPhoneNumber}
        landlordPhoneNumber={landlordPhoneNumber}
      />
    </>
  );
};

export default ShareButton;
